function e(n) {
  const t = n.startOf("month").startOf("week"), a = t.add(42, "day");
  return [t, a];
}
export {
  e as useCalendarBounds
};
